export default (arr,carSettingName) => {
  return arr.sort((a,b)=>{
    const numberA = `${parseFloat(a[carSettingName]) || a[carSettingName]}`
    const numberB = `${parseFloat(b[carSettingName]) || b[carSettingName]}`
    if(!isNaN(numberA) && !isNaN(numberB)){
        if(numberA * 1 < numberB * 1){
            return -1
        } 
        if(numberA * 1 > numberB * 1){
            return 1
        }
        return 0
    } 
    return numberA.localeCompare(numberB)
  })
}